:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fd-column{flex-direction:column;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._pos-absolute{position:absolute;}
:root ._t-5px{top:5px;}
:root ._l-5px{left:5px;}
:root ._z-10{z-index:10;}
:root ._pos-relative{position:relative;}
:root ._bg-primary{background-color:var(--primary);}
:root ._pt-12px{padding-top:12px;}
:root ._pb-12px{padding-bottom:12px;}
:root ._pr-18px{padding-right:18px;}
:root ._pl-18px{padding-left:18px;}
:root ._cur-pointer{cursor:pointer;}
:root ._fd-row{flex-direction:row;}
:root ._gap-t-space-sma3456{gap:var(--t-space-small);}
:root ._items-center{align-items:center;}